import {
  RESET_SIMULATED_USER_DETAILS,
  SET_SIMULATED_USER_DETAILS,
} from "../action.js";
import { simulatedUserDetails } from "./initial-store.js";

const initialState = simulatedUserDetails;

function simulatedUserDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SIMULATED_USER_DETAILS:
      return Object.assign({}, state, action.payload);
    case RESET_SIMULATED_USER_DETAILS:
      return {};
    default:
      return state;
  }
}

export default simulatedUserDetailsReducer;
